import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Input,
  Label,
  Form,
} from "reactstrap";
import * as ApiManager from "helpers/ApiManager.tsx";
import { toast } from "react-toastify";

function ChangePassword() {
  const oldPassRef = useRef();
  const newPassRef = useRef();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    if (loading) return;
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    const oldPass = oldPassRef.current.value;
    const newPass = newPassRef.current.value;

    try {
      const res = await ApiManager.ChangePassword({
        oldPass,
        newPass,
      });

      if (res && res.status === "success") {
        navigate("/me");
        toast.success("Your password has been changed");
      } else {
        setErrorMsg(res.message);
      }
    } catch (err) {
      setErrorMsg("Unknown error occured. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Card>
      <CardHeader>
        <CardTitle tag="h3">Change Password</CardTitle>
      </CardHeader>
      <CardBody>
        {errorMsg && <Alert color="danger">{errorMsg}</Alert>}
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="name" className="text-primary">
              Current Password
            </Label>
            <Input
              type="password"
              id="name"
              placeholder="Enter old password"
              innerRef={oldPassRef}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="name" className="text-primary">
              New password
            </Label>
            <Input
              type="password"
              id="name"
              placeholder="Enter new password"
              innerRef={newPassRef}
              required
            />
          </FormGroup>

          <Button color="primary" block disabled={loading}>
            {loading ? "Loading..." : "Change Password"}
          </Button>
        </Form>
      </CardBody>
    </Card>
  );
}

export default ChangePassword;
